import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import ReactJson from 'react-json-view';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import showAlert from '../../../common/utils/alert';
import { showAlertHtml } from '../../../common/utils/alert';
import { Form, Formik, Field } from 'formik';
import * as Yup from 'yup';
import FormFieldWithLabel from '../../common/FormFieldWithLabel';
import Select from 'react-select';
import CustomRadio from '../../../common/ui/CustomRadio';
import voca from 'voca';
import { collectionTypeBadge } from '../../../common/utils/validate';
export default class CollectionDetail extends Component {
  static propTypes = {
    collection: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
  };

  state = {
    openCollectionModal: false,
    openCrudModal: false,
  };

  handleClone = () => {
    const { projectId, actions, version, collection } = this.props;
    const text = 'Do you want to clone this Collection ?';
    const preConfirm = async () => {
      await actions.cloneCollection({
        projectId: projectId,
        version: version,
        collection: collection,
      });
      await actions.loadProjectCollections({
        projectId: projectId,
        version: version,
      });
    };
    const confirmButtonText = 'Yes, Clone it!';
    showAlert(text, preConfirm, confirmButtonText);
  };

  createValidationSchema = () => {
    return Yup.object().shape({
      selectedPage: Yup.object()
        .shape({
          add: Yup.boolean(),
          list: Yup.boolean(),
          update: Yup.boolean(),
        })
        .test(
          'at-least-one-checked',
          'At least one page is required',
          (value) => value.add || value.list || value.update,
        ),
    });
  };

  generateCRUDPages = (values) => {
    const { actions, projectId, collection, version, homeActions } = this.props;
    const body = {
      selectedPage: values.selectedPage,
      selectedLayout: values.selectedLayout,
      collectionUuid: collection.uuid,
    };

    const confirmationMsg = `Do you want to proceed? <br/> This will generate dynamic pages with all the necessary actions you've selected and bind them to the layout if chosen.`;
    const preConfirm = async () => {
      await actions.generateCrudPages({
        projectId,
        collectionName: collection.collectionTitle,
        version,
        body,
      });

      await homeActions.loadPages({ projectId, version });
    };
    const confirmButtonText = 'Yes, Generate';
    showAlertHtml(confirmationMsg, preConfirm, confirmButtonText);
  };

  parseCollectionView = () => {
    const newCollection = { ...this.props.collection };
    delete newCollection._id;
    delete newCollection.__v;
    delete newCollection.collectionTitle;
    delete newCollection.createdAt;
    delete newCollection.updatedAt;
    delete newCollection.projectId;
    delete newCollection.isDeleted;
    delete newCollection.collectionIndex;
    delete newCollection.isPluginCollection;
    delete newCollection.isInMemory;
    delete newCollection.lastRefreshTime;

    return (
      <ReactJson
        name={false}
        iconStyle="triangle"
        enableClipboard={true}
        src={newCollection}
        theme="rvj-default"
        collapsed={true}
      />
    );
  };

  toggleOpenCollectionModal = () => {
    this.setState({ openCollectionModal: !this.state.openCollectionModal });
  };

  showConfigButton = () => {
    const { projectId, collection, version } = this.props;
    const { collectionTitle, uuid, collectionName } = collection;
    return (
      <Link
        to={`/collections/${version}/v/${projectId}/edit/${uuid}`}
        className="btn btn-primary btn-xs"
        title={`Configure ${collectionTitle}`}
        onClick={() => {
          Mixpanel.track('Opens Collection Configuration', { collectionName, uuid });
        }}
      >
        <i className="wb webconnect-cog" size={'md'}></i>
      </Link>
    );
  };

  showViewDataButton = () => {
    const { projectId, collection, version } = this.props;
    const {
      collectionTitle,
      uuid,
      collectionName,
      // willPersist,
      // externalDatabaseId
    } = collection || {};
    // let showCollectionItems = true;
    // if (collection) {
    //   showCollectionItems = willPersist && !externalDatabaseId ? true : false;
    // }

    //TODO: Need to Handle Non-Persistent Collection Item Data accessibility
    // if (showCollectionItems) {
    return (
      <Link
        to={`/collections/${version}/v/${projectId}/items/${uuid}/name/${collectionName}`}
        className="btn btn-theme-submit btn-xs"
        title={`View ${collectionTitle} Data`}
        onClick={() => {
          Mixpanel.track('Opens Collection Item list', { collectionName, uuid });
        }}
      >
        <i className="wb webconnect-stack icon--center" size={'md'}></i>&nbsp;
      </Link>
    );
    // } else {
    //   return (
    //     <button className="btn btn-xs" title={`View Data`} disabled={true}>
    //       <i className="wb webconnect-stack icon--center" size={'md'}></i>&nbsp;
    //     </button>
    //   );
    // }
  };

  openCrudModal = () => {
    this.setState({ openCrudModal: true });
  };

  toggleOpenCrudModal = () => {
    this.setState({ openCrudModal: !this.state.openCrudModal });
  };

  handleSubmit = async (values) => {
    this.setState({ openCrudModal: !this.state.openCrudModal });
    await this.generateCRUDPages(values);
  };

  parseCrudModalView = (layouts) => {
    const { collectionTitle } = this.props.collection;
    let layoutOptions = layouts.map((layout) => ({ value: layout.uuid, label: layout.role }));
    return (
      <Formik
        initialValues={{
          selectedLayout: [],
          selectedPage: {
            list: false,
            update: false,
            add: false,
          },
        }}
        validationSchema={this.createValidationSchema()}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          this.handleSubmit(values);
          setSubmitting(false);
          resetForm();
        }}
      >
        {({ values, errors, setFieldValue }) => (
          <Form className="form-horizontal">
            <div className="form-group">
              <FormFieldWithLabel
                cta={false}
                label="Select Layout"
                icon="select"
                infoIcon={true}
                infoDescription={`Select a layout from the provided options to bind the CRUD operations`}
              >
                <Select
                  isMulti
                  options={layoutOptions}
                  onChange={(option) => setFieldValue('selectedLayout', option)}
                  className="custom-select-container"
                  classNamePrefix="custom-select"
                  value={values.selectedLayout}
                />
              </FormFieldWithLabel>
            </div>
            <div className="form-group">
              <FormFieldWithLabel label="Select Page " icon="toggle" isRequired={true}>
                <div className="d-flex align-items-center mt-2">
                  <div className="mr-4">
                    <div className="input-group" title={`${collectionTitle} List`}>
                      <div className="input-group-prepend"></div>
                      <div className="form-check">
                        <CustomRadio label={`${collectionTitle} List`} isRadio={false}>
                          <Field
                            type="checkbox"
                            name="selectedPage.list"
                            className="form-check-input"
                          />
                        </CustomRadio>
                      </div>
                    </div>
                  </div>
                  <div className="mr-4">
                    <div className="input-group" title={`Update ${collectionTitle}`}>
                      <div className="input-group-prepend"></div>
                      <div className="form-check">
                        <CustomRadio label={`Update ${collectionTitle}`} isRadio={false}>
                          <Field
                            type="checkbox"
                            name="selectedPage.update"
                            className="form-check-input"
                          />
                        </CustomRadio>
                      </div>
                    </div>
                  </div>
                  <div className="mr-4">
                    <div className="input-group" title={`Add ${collectionTitle}`}>
                      <div className="input-group-prepend"></div>
                      <div className="form-check">
                        <CustomRadio label={`Add ${collectionTitle}`} isRadio={false}>
                          <Field
                            type="checkbox"
                            name="selectedPage.add"
                            className="form-check-input"
                          />
                        </CustomRadio>
                      </div>
                    </div>
                  </div>
                </div>
              </FormFieldWithLabel>
              {errors.selectedPage && typeof errors.selectedPage === 'string' ? (
                <div className="text-danger" style={{ marginLeft: '2rem' }}>
                  {errors.selectedPage}
                </div>
              ) : null}
            </div>
            <div className="d-flex justify-content-between modal-footer">
              <button
                type="button"
                className="btn btn-xs btn-theme-default-outlined"
                onClick={this.toggleOpenCrudModal}
              >
                <span>
                  <i className={`wb webconnect-times`}></i>&nbsp;Cancel
                </span>
              </button>
              <button type="submit" className="btn btn-xs btn-theme-submit">
                <span>
                  {' '}
                  <i className={`wb webconnect-skip-end-circle-fill`}></i>&nbsp;Proceed
                </span>
              </button>
            </div>
          </Form>
        )}
      </Formik>
    );
  };

  render() {
    const { collection, snippets } = this.props;
    const { collectionTitle, willPersist, description = '', inUse = true } = collection || {};
    const layouts = snippets.filter(
      (snippet) => snippet.snippetType === 'PAGE_LAYOUT' && snippet.role && snippet.role !== '',
    );
    return (
      <tr>
        <td className="align-middle" style={{ width: '30%' }}>
          {collectionTitle}
        </td>
        <td className="align-middle" title={description} style={{ width: '60%' }}>
          {voca.truncate(`${description}`, 80)}
        </td>
        <td className="align-middle" style={{ width: '15%' }}>
          {collectionTypeBadge(inUse, 'inuse', 'collection')}
        </td>
        <td className="align-middle" style={{ width: '15%' }}>
          {collectionTypeBadge(willPersist, 'persist')}
        </td>
        <td className="align-middle text-right">
          {this.showViewDataButton()}
          &nbsp;
          {this.showConfigButton()}
          &nbsp;
          <button
            type="button"
            className="btn btn-theme-green btn-xs"
            title={`View ${collectionTitle} JSON`}
            onClick={this.toggleOpenCollectionModal}
          >
            <i className="wb webconnect-braces" size={'md'}></i>
          </button>
          &nbsp;
          <button
            type="button"
            className="btn btn-theme-submit btn-xs"
            title={`Clone ${collectionTitle} `}
            onClick={this.handleClone}
          >
            <i className="wb wb webconnect-clone" size={'md'}></i>
          </button>
          <Modal
            isOpen={this.state.openCollectionModal}
            toggle={this.toggleOpenCollectionModal}
            backdrop="static"
            size="lg"
          >
            <ModalHeader toggle={this.toggleOpenCollectionModal} className="border-bottom">
              <strong>{collectionTitle} Configuration</strong>
            </ModalHeader>
            <ModalBody>{this.parseCollectionView()}</ModalBody>
          </Modal>
          <button
            type="button"
            className="btn btn-primary btn-xs ml-1"
            title="Generate CRUD Pages"
            onClick={this.openCrudModal}
          >
            <i className="wb wb webconnect-journal-plus" size={'md'}></i>
          </button>
          <Modal
            isOpen={this.state.openCrudModal}
            toggle={this.toggleOpenCrudModal}
            backdrop="static"
            size="lg"
          >
            <ModalHeader toggle={this.toggleOpenCrudModal} className="border-bottom">
              Select Layout and Pages you want to add
            </ModalHeader>
            <ModalBody>{this.parseCrudModalView(layouts)}</ModalBody>
          </Modal>
        </td>
      </tr>
    );
  }
}
